import React, { useState, useMemo } from "react";
import moment from "moment";
import { IoMdEye } from "react-icons/io";
import Popup from "./Popup";
import { getDaysBetweenDates } from "../../Utils/leaveUtils";
import { MdArrowRightAlt } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import Textarea from "./Textarea";
import { getUser, hasPermission, isAdmin } from "../../Utils/auth";
import { Link } from "react-router";
import { getLeaveLabel } from "../../Utils/getUserUtitls";

const LeaveApproveTable = ({
  data,
  handleApprove,
  requestOpen,
  setRequestOpen,
  handleReject,
  requestRejectOpen,
  setRequestRejectOpen,
  reject_reason,
  setRejectReason,
  error,
  submitted,
}) => {
  const [selectedRow, setSelectedRow] = useState({});

  const currentUser = getUser();

  const handleRequestOpen = (row) => {
    setSelectedRow(row);
    setRequestOpen(true);
  };

  const handleRequestRejectOpen = (row) => {
    setSelectedRow(row);
    setRequestRejectOpen(true);
  };
  return (
    <div className="w-full rounded-lg">
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-sm">
          <thead>
            <tr className="h-[52px] bg-white border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-3 text-left text-sm font-semibold">S No.</th>
              <th className="px-3 text-left text-sm font-semibold">Name</th>
              <th className="px-3 text-left text-sm font-semibold">Type</th>
              {/* <th className="px-3 text-center text-sm font-semibold">Days</th> */}
              <th className="px-3 text-center text-sm font-semibold">Dates</th>
              <th className="px-3 text-center text-sm font-semibold">
                Applied Date
              </th>
              <th className="px-3 text-center text-sm font-semibold">Status</th>
              <th className="px-3 text-center text-sm font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, idx) => (
                <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                  <td className="relative text-left py-3 px-3 w-[80px]">
                    <p className="text-sm">{idx + 1}</p>
                  </td>
                  <td className="text-sm text-left py-3 px-3 w-[180px]">
                    {row.employee}
                  </td>
                  <td className="text-sm text-left py-3 px-3 w-[150px]">
                    {row.leave_type}
                  </td>
                  {/* <td className="text-sm text-center py-3">
                    {getDaysBetweenDates(
                      moment(new Date(row.start_date)).format("YYYY-MM-DD"),
                      moment(new Date(row.end_date)).format("YYYY-MM-DD")
                    )}
                  </td> */}
                  <td className="text-sm text-center py-3 px-3 w-[250px]">
                    <div className="flex justify-center gap-2 items-center">
                      {moment(row.start_date).format("DD MMM YYYY")}
                      <MdArrowRightAlt />
                      {moment(row.end_date).format("DD MMM YYYY")}
                    </div>
                  </td>
                  <td className="text-sm text-center py-3 px-3 w-[150px]">
                    {moment(row.applied_at).format("DD MMM YYYY")}
                  </td>
                  <td className="text-sm text-center py-3 px-3 font-medium w-[200px]">
                    <span className="flex justify-center items-center px-2 py-1 w-fit mx-auto rounded bg-[#de2b26]/10 text-[#142b70]">
                      {row.status}
                    </span>
                  </td>
                  <td className="text-sm text-center py-3 px-3 font-medium">
                    {isAdmin() ? (
                      <div className="flex justify-center gap-2 items-center">
                        <FaCheck
                          onClick={() => handleRequestOpen(row)}
                          className="text-[#00b734] bg-[#00932a]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                        <IoCloseSharp
                          onClick={() => handleRequestRejectOpen(row)}
                          className="text-[#ff0000] bg-[#ff0000]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                      </div>
                    ) : currentUser?.role_id === 4 &&
                      row.status === "Pending at HR" ? (
                      ""
                    ) : hasPermission("approve_leaves") &&
                      hasPermission("reject_leaves") ? (
                      <div className="flex justify-center gap-2 items-center">
                        <FaCheck
                          onClick={() => handleRequestOpen(row)}
                          className="text-[#00b734] bg-[#00932a]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                        <IoCloseSharp
                          onClick={() => handleRequestRejectOpen(row)}
                          className="text-[#ff0000] bg-[#ff0000]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                      </div>
                    ) : hasPermission("approve_leaves") ? (
                      <div className="flex justify-center gap-2 items-center">
                        <FaCheck
                          onClick={() => handleRequestOpen(row)}
                          className="text-[#00b734] bg-[#00932a]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                      </div>
                    ) : hasPermission("reject_leaves") ? (
                      <div className="flex justify-center gap-2 items-center">
                        <IoCloseSharp
                          onClick={() => handleRequestRejectOpen(row)}
                          className="text-[#ff0000] bg-[#ff0000]/10 p-1 text-2xl rounded-md cursor-pointer"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Popup
        isOpen={requestOpen}
        onClose={() => setRequestOpen(false)}
        title={`<div>${selectedRow?.employee}<br/><span style="font-size: 13px;margin-top: -10px;display: block;font-weight: 400;">Leave Request</span></div>`}
        isHtml={true}
      >
        <div className="flex flex-col gap-3 mt-[30px] border shadow rounded-xl p-6">
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Type</p>
            <span className="text-sm text-[#142b70]">
              {selectedRow?.leave_type}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Number of Days</p>
            <span className="text-sm text-[#142b70]">
              {getDaysBetweenDates(
                moment(new Date(selectedRow?.start_date)).format("YYYY-MM-DD"),
                moment(new Date(selectedRow?.end_date)).format("YYYY-MM-DD")
              )}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Sub Type</p>
            <span className="text-sm text-[#142b70]">
              {getLeaveLabel(selectedRow?.sub_type)}
            </span>
          </div>
          {selectedRow?.medical_certificate && (
            <div className="flex justify-between gap-2 w-full pb-2 border-b">
              <p className="text-sm text-[#142b70]/70">Medical Certificate</p>
              <Link
                to={selectedRow?.medical_certificate}
                target="_blank"
                className="text-sm text-[#142b70] underline"
              >
                View
              </Link>
            </div>
          )}
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Start Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.start_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">End Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.end_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Applied At</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.applied_at)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            {/* <p className="text-sm text-[#142b70]/70">Reason</p> */}
            <Textarea
              value={selectedRow?.reason}
              disable={true}
              className="bg-[#F9F9F9] border-0 shadow"
            />
          </div>
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4">
          <button
            onClick={() => setRequestOpen(false)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
          >
            Close
          </button>
          <button
            onClick={() => handleApprove(selectedRow?.id)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] bg-[#de2b26] text-white font-medium"
          >
            Approve
          </button>
        </div>
      </Popup>
      {/* Reject Popup */}
      <Popup
        isOpen={requestRejectOpen}
        onClose={() => setRequestRejectOpen(false)}
        title={`<div>${selectedRow?.employee}<br/><span style="font-size: 13px;margin-top: -10px;display: block;font-weight: 400;">Leave Request</span></div>`}
        isHtml={true}
      >
        <div className="flex flex-col gap-3 mt-[30px] border shadow rounded-xl p-6">
          {error && (
            <div className="mb-4 w-full rounded-lg bg-red-50 border border-red-400 text-red-700 px-4 py-2">
              {error}
            </div>
          )}
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Type</p>
            <span className="text-sm text-[#142b70]">
              {selectedRow?.leave_type}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Number of Days</p>
            <span className="text-sm text-[#142b70]">
              {getDaysBetweenDates(
                moment(new Date(selectedRow?.start_date)).format("YYYY-MM-DD"),
                moment(new Date(selectedRow?.end_date)).format("YYYY-MM-DD")
              )}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Leave Sub Type</p>
            <span className="text-sm text-[#142b70]">
              {getLeaveLabel(selectedRow?.sub_type)}
            </span>
          </div>
          {selectedRow?.medical_certificate && (
            <div className="flex justify-between gap-2 w-full pb-2 border-b">
              <p className="text-sm text-[#142b70]/70">Medical Certificate</p>
              <Link
                to={selectedRow?.medical_certificate}
                target="_blank"
                className="text-sm text-[#142b70] underline"
              >
                View
              </Link>
            </div>
          )}
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Start Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.start_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">End Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.end_date)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Applied At</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.applied_at)).format("DD MMM, YYYY")}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            {/* <p className="text-sm text-[#142b70]/70">Reason</p> */}
            <Textarea
              value={selectedRow?.reason}
              disable={true}
              className="bg-[#F9F9F9] border-0 shadow"
            />
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/70">Reject Reason</p>
            <Textarea
              value={reject_reason}
              onChange={(e) => setRejectReason(e.target.value)}
              error={!reject_reason && submitted}
            />
          </div>
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4">
          <button
            onClick={() => setRequestRejectOpen(false)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
          >
            Close
          </button>
          <button
            onClick={() => handleReject(selectedRow?.id)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] bg-[#de2b26] text-white font-medium"
          >
            Reject
          </button>
        </div>
      </Popup>
    </div>
  );
};

export default LeaveApproveTable;
